import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/shared/http.service';

@Injectable({
    providedIn: 'root',
})
export class UserRequestService {
    constructor(private httpService: HttpService) { }

    getUserRequestList(data: any) {
        return this.httpService.functionPost(`getcustomertickets`, data);
    }

    postUserRequest(data: any) {
        return this.httpService.functionPost(`createticket`, data);
    }

    cancelUserRequest(data: any) {
        return this.httpService.functionPost(`performticketaction`, data);
    }
}
